<div class="table-container">
<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table table-scrollbar">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef> Code </th>
    <td mat-cell *matCellDef="let data">{{data.id ? data.id : emptyValuePlaceholder}}</td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef> Omschrijving </th>
    <td mat-cell *matCellDef="let data">{{data.description ? data.description : emptyValuePlaceholder}}</td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th mat-header-cell *matHeaderCellDef> Tarief % </th>
    <td mat-cell [ngClass]="{'red': data.amount < 0}" *matCellDef="let data">{{getAmountInPercentage(data.amount)}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
</div>
